import {WidgetSettings} from '../../../components/layout/widget/widget-settings';
import {WidgetSettingsDefinition} from '../../../components/layout/widget/widget-settings-definition';
import {TableColumnsSizingMode} from '../../../components/tables/table';
import {DexTxHistoryTableColumnConfig} from '../dex-tx-history-table';
import {TxHistoryMeta, TxHistoryStatus} from '../tx-history-rec';

export enum DexTxHistoryWidgetTab {
    RECENT  = 'RECENT',
    HISTORY = 'HISTORY'
}

export interface DexTxHistoryWidgetFiltersSettings {
    hash: string;
    status: TxHistoryStatus[];
    address: string;
    method: TxHistoryMeta['method'];
}

export interface DexTxHistoryWidgetSettings extends WidgetSettings {
    columns: DexTxHistoryTableColumnConfig[];
    columnsResizingMode: TableColumnsSizingMode;
    tab: DexTxHistoryWidgetTab;
    filters: Partial<DexTxHistoryWidgetFiltersSettings>;
}

export interface DexTxHistoryWidgetSettingsDef extends WidgetSettingsDefinition {
    columns: DexTxHistoryTableColumnConfig[];
    columnsResizingMode: TableColumnsSizingMode;
    tab: DexTxHistoryWidgetTab;
    filters: Partial<DexTxHistoryWidgetFiltersSettings>;
}
